import { Col, Container, Row } from "react-bootstrap";

import Modal from "../modal";

import token from "../../assets/token.png";

import "./infoModalStyles.css";

const InfoModal = ({
  title,
  weightText,
  viewPoolContractURL,
  acquireText,
  footerLabel,
  displayModal,
  setDisplayModal,
}) => {
  const getBodyContent = () => (
    <Container className="info-modal-container">
      <Row className="info-modal-row">
        <Col xs={12}>
          <Row className="justify-content-center">
            <p className="info-modal-text text-center">{weightText}</p>
          </Row>
          <Row className="mt-4 mb-4">
            <button
              className="info-modal-button purple mx-auto w-100"
              onClick={() => window.open(viewPoolContractURL)}
            >
              View pool contract
            </button>
          </Row>
          <Row className="justify-content-center">
            <p className="info-modal-text text-center">{acquireText}</p>
          </Row>
        </Col>
      </Row>
    </Container>
  );

  return (
    <Modal
      size="md"
      title={title}
      imageTitle={token}
      bodyContent={getBodyContent()}
      showFooter={true}
      showButtonFooter={false}
      footerLabel={footerLabel}
      displayModal={displayModal}
      setDisplayModal={setDisplayModal}
    />
  );
};

export default InfoModal;
